import { StringKeyDictionary } from "../commonInterfaces";
import { AdditionalData, Entity } from "../core/components/commonApp";
import { EditableGrid, EditableGridProps, field, InGridButtonClickParams, InGridToolBarButton, Schema } from "../core/components/editableGrid/editableGrid";
import { ValidationBuilder } from "../core/components/editableGrid/validationBuilder";
import { ToolBar, ToolBarInGridButtonType, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { EntityServiceReport } from "./serviceReport";
import React from "react";

export class ServiceReportTimesInGrid extends React.Component<ServiceReportTimesGridProps, ServiceReportTimesGridState>{
    editableGridRef: EditableGrid;
    private timeTypes = []
    private TIME_TYPE_BREAK = 5;

    constructor(props: ServiceReportTimesGridProps) {
        super(props);
        this.state = {
        };
        this.setUtcOffset(this.props.entity.Adrnr);
        this.timeTypes = props.entity.UseDynZeittypen ? props.dataSources["dynZeittypen"] : props.dataSources["zeittypen"];
    }

    private setUtcOffset(adrNr: string) {
        HTTPService.get<JsonResultClass<number>>("TimeZoneLookup/GetUTCOffsetByAdrNr", { adrNr: adrNr }).then((result) => {
            this.setState({ UtcOffsetByAdrNr: result.Data ?? 0 });
        });
    }

    private getMachineAdditionalData = async (maschNr: string): Promise<AdditionalData> => {
        let result = await HTTPService.get<AdditionalData>("MachineLookUp/GetMachineAdditionalData", { id: maschNr });
        return result;
    }

    private flag: boolean = false;
    onGridDataChanged = async (action: string, fieldName: string, dataItems: any) => {
        if (action == "itemchange" && !this.flag) {
            this.handleItemChanged(fieldName, dataItems);
            this.flag = false;
        }
        else if (action == "add") {
        }
        else if (action == "remove") {

        }
        if (this.props.onChange)
            this.props.onChange();
    }

    private resolveAdditionalData = async (newValue: any, fieldName: string, fullObject) => {
        switch (fieldName) {
            case "Maschnr":
                let maschineView = await this.getMachineAdditionalData(newValue);
                if (Helper.hasValue(maschineView))
                    return maschineView;
                break;
            case "Kls":
                let klsAdditionalData: AdditionalData = { Description: fullObject ? fullObject.verursacher : "" };
                return klsAdditionalData;
        }
    }

    private handleItemChanged(fieldName: string, dataItems) {
        let changedDataItem = dataItems[0];
        this.flag = true;
        let dataItem: EntityServiceReportTime = changedDataItem;
        switch (fieldName) {
            case "Datum":
                changedDataItem.set("WeekDay", kendo.toString(kendo.parseDate(changedDataItem.Datum), "ddd"));
                dataItem.DatumUtc = Helper.dates.getISODateString(changedDataItem.Datum);
                break;
            case "Timetypeisguid":
                let dynTimeType = this.props.dataSources.parentServiceReport.lookups.dynzeittypen.find((c) => c.IsGuid == dataItem.Timetypeisguid);
                if (Helper.hasValue(dynTimeType)) {
                    this.ClearDriverAndDistanceIfRequired(dynTimeType.Id, changedDataItem);
                    changedDataItem.set("Zeittyp", dynTimeType.Id);
                }
                break;
            case "Zeittyp":
                changedDataItem.set("Timetypeisguid", null);
                this.ClearDriverAndDistanceIfRequired(dataItem.Zeittyp, changedDataItem);
                break;
            case "Zvon":
            case "Zbis":
            case "Utcoffset":
            case "UtcoffsetZBis":
                this.setTotalTime(changedDataItem);
                break
        }
        if (this.props.entity.RueckreiseModusActivated)
            changedDataItem.set("ErfasstNachSignatur", true);
        changedDataItem.set("Changed", true);
        if (this.props.handleItemChanged)
            this.props.handleItemChanged(fieldName, dataItem);
    }

    private getTotalTime = (dataItem) => {
        return this.props.entity.SaveTimeShift ? (dataItem.Zbis - dataItem.UtcoffsetZBis) - (dataItem.Zvon - dataItem.Utcoffset) : (dataItem.Zbis - dataItem.Zvon);
    }

    private setTotalTime = (changedDataItem) => {
        var totalTime = this.getTotalTime(changedDataItem);
        changedDataItem.set("TotalTime", totalTime);
    }

    private ClearDriverAndDistanceIfRequired(timeType: number, changeDataItem: any) {
        if (timeType != 1 && timeType != 3 && timeType != 9) {
            changeDataItem.set("IsDriver", null);
            changeDataItem.set("Traveldistance", null);
        }
    }

    private checkPmZeiten(i: any) {
        return !(i.ZvonPm > 0 || i.ZbisPm > 0);
    }

    private createNewEntity(): EntityServiceReportTime {
        let newEntry: EntityServiceReportTime = {
            IsNew: true,
            Zvon: 0,
            Zbis: 0,
            Utcoffset: this.state.UtcOffsetByAdrNr,
            UtcoffsetZBis: this.state.UtcOffsetByAdrNr,
            Bemerkung: "",
            Isguid: "{" + kendo.guid() + "}",
            Changed: false,
            RecordRight: { CanRead: this.props.entity.RecordRight.CanRead, CanWrite: this.props.entity.RecordRight.CanWrite },
            IndividualFields: {},
            IsWatchable: false,
            IsWatched: false,
            Pindex: this.props.entity.Pindex,
            Projnr: this.props.entity.Projnr,
            ErfasstNachSignatur: this.props.entity.RecordRight.IsRueckModusAdded,
            Traveldistance: null
        }

        HTTPService.get<JsonResultClass<number>>("TimeZoneLookup/GetUTCOffsetByAdrNr", { adrNr: this.props.entity.Adrnr }).then((result) => {
            if (result.Code == 0) {
                let utcOffsetInMinutes = result.Data;
                newEntry.Utcoffset = utcOffsetInMinutes;
                newEntry.UtcoffsetZBis = utcOffsetInMinutes;
            }
            else {
                console.error(result.Message);
            };
        });
        return newEntry;
    }

    private calcNewValues(dataSource: kendo.data.DataSource, newEntry: EntityServiceReportTime) {
        let entries = (dataSource.data() as any) as EntityServiceReportTime[];
        if (dataSource.filter)
            entries = new kendo.data.Query(entries).filter(dataSource.filter()).data;
        
        let newDate = kendo.parseDate(this.props.entity.Dvon);
        let newUtcOffset = newEntry.Utcoffset;

        if (entries.length >= 1) {
            newDate = entries.filter(x => Helper.hasValue(x.Datum)).reduce((prev, current) => (prev.Datum > current.Datum) ? prev : current).Datum;
            let lastEntry = entries[entries.length - 1];
            newUtcOffset = this.props.entity.SaveTimeShift ? lastEntry.UtcoffsetZBis : newUtcOffset = lastEntry.Utcoffset;
        }
        
        newEntry.Datum = newDate;
        newEntry.DatumUtc = Helper.dates.getISODateString(newDate);
        newEntry.WeekDay = kendo.toString(newDate, "ddd");
        newEntry.Utcoffset = newUtcOffset;
        if (this.props.entity.SaveTimeShift)
            newEntry.UtcoffsetZBis = newUtcOffset;
        if (entries.length >= 1) {
            let maxZbis = entries.filter(x => Helper.hasValue(x.Datum) && x.Datum == newDate).reduce((prev, current) => (prev.Zbis > current.Zbis) ? prev : current);
            if (Helper.hasValue(maxZbis) && maxZbis.Zbis > newEntry.Zvon) {
                newEntry.Zvon = maxZbis.Zbis;
                if (newEntry.Zvon >= newEntry.Zbis && (+newEntry.Zvon + +60) <= 1440) {
                    newEntry.Zbis = +newEntry.Zvon + +60;
                } else {
                    newEntry.Zbis = 1440;
                }
            }
        }
        newEntry.TotalTime = this.getTotalTime(newEntry);
    }

    public getGridData(): any {
        let currentItems = this.editableGridRef.getGridData();
        return currentItems;
    }

    public getEntries(): any {
        let currentItems = this.editableGridRef.getData();
        return currentItems;
    }

    private rowReadOnly = (dataItem) => {
        let readonlyRueckModus = !dataItem.ErfasstNachSignatur && this.props.entity.RecordRight.IsRueckModusAdded;
        let readonly = Helper.hasValue(dataItem.Readonly) && dataItem.Readonly == 1;
        return readonlyRueckModus || readonly;
    }

    groupHeaderColumnTemplateTotalTime = (group: any) => {
        const getValue = (item) => {
            let value = 0;
            if (item.hasOwnProperty("Zeittyp") && item["Zeittyp"] == 5)
                return value;

            if (item.hasOwnProperty("TotalTime")) {
                value = item["TotalTime"];
            } else if (item.hasOwnProperty("items")) {
                value = item.items.reduce((acc, childItem) => acc + getValue(childItem), 0);
            }
            return value;
        };

        let totalValue = group.items.reduce((acc, item) => acc + getValue(item), 0);

        let timeStringValue = Helper.dates.fromMinutesSinceMidnight(totalValue);
        return timeStringValue;
    };

    handleButtonClick = (p: InGridButtonClickParams) => {
        switch (p.id) {
            case "new":
                let newItem: EntityServiceReportTime = this.createNewEntity();
                if(this.props.createNewEntity)
                    this.props.createNewEntity(newItem);
                this.calcNewValues(p.dataSource, newItem);
                p.actions.add(newItem);
                break;
            case "edit":
                p.actions.editSelected();
                break;
            case "delete":
                p.actions.deleteSelected(true);
                break;
        }
    }

    render() {
        let editable = this.props.entity.RecordRight.CanWrite && !this.props.entity.RecordRight.IsRueckModusReadOnly;

        const buttons: Array<InGridToolBarButton> = [];
        buttons.push({ type: ToolBarInGridButtonType.NEW, id: "new" });
        buttons.push({ type: ToolBarInGridButtonType.EDIT, id: "edit", enabled: (p) => this.props.entity.RecordRight.CanWrite && p.hasSingleSelection });
        buttons.push({ type: ToolBarInGridButtonType.DELETE, id: "delete" });

        let schema = new Schema();
        schema.Id = "Isguid";
        schema.fields["Isguid"] = new field("string");
        return (
            <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <EditableGrid 
                    editable={editable}
                    data={this.props.data}
                    resolveAdditionalData={this.resolveAdditionalData}
                    onDataChanged={this.onGridDataChanged}
                    ref={(ref) => this.editableGridRef = ref}
                    rowReadOnly={this.rowReadOnly}
                    gridOptions={this.props.gridOptions}
                    schema={schema}
                    buttons={buttons}
                    onButtonClick={this.handleButtonClick}
                    onRequestItemValidation={(columns, dataItem) => {
                        return new ValidationBuilder()
                            .checkReqiredFields(columns, dataItem)
                            .addError(dataItem.TotalTime < 0, Helper.getTranslation("WebSMS.ServiceReport.Validations.NotNegativ"))
                            .build();
                    }}
                    pageable={this.props.pagable ?? true}
                    {...this.props}
                    {...{ groupHeaderColumnTemplateTotalTime: this.groupHeaderColumnTemplateTotalTime }}
                    id="srTimes"
                />
            </div>
        );
    }
}

export interface ServiceReportTimesGridProps extends EditableGridProps {
    entity: EntityServiceReport;
    data: EntityServiceReportTime[];
    gridOptions: any;
    dataSources: any;
    onChange?: () => void;
    pagable?: boolean;
    createNewEntity?: (newEntity) => void;
    handleItemChanged?: (fieldName, dataItem) => void;
}

export interface ServiceReportTimesGridState {
    UtcOffsetByAdrNr?: number;
}

export interface EntityServiceReportTime extends Entity {
    Datum?: Date;
    WeekDay?: string;
    Zvon?: number;
    Zbis?: number;
    Bemerkung?: string;
    Isguid?: string,
    Dgfzeile?: number,
    Zeittyp?: number,
    ZeittypText?: string,
    Feiertagart?: number
    Changed?: boolean;
    Timetypeisguid?: string;
    Utcoffset?: number;
    UtcoffsetZBis?: number;
    Pindex?: number;
    Projnr?: string;
    ErfasstNachSignatur?: boolean;
    Pos?: any;
    Kls?: string;
    Kls_additional_data?: AdditionalData;
    Maschnr?: string;
    Maschnr_additional_data?: AdditionalData;
    Traveldistance?: number;
    Readonly?: number;
    DatumUtc?: string;
    Schluessel_additional_data?: AdditionalData;
    TotalTime?: number;
}